(() => {
  "use strict";
  const root = () =>
      document.querySelector('.mqsm[aria-label="Indicator Accessories"]'),
    el = (tag, text) => {
      const node = document.createElement(tag);
      if (text != null) node.textContent = text;
      return node;
    },
    clean = (value) => String(value || "").trim();
  function tags(template) {
    try {
      return JSON.parse(template.dataset.tags || "[]").map((value) =>
        String(value).toLowerCase(),
      );
    } catch (_error) {
      return [];
    }
  }
  function type(record) {
    const text = (
      record.title +
      " " +
      record.productType +
      " " +
      record.tags.join(" ")
    ).toLowerCase();
    if (/contact point|stylus|ball point|measuring tip/.test(text))
      return "Contact points & styli";
    if (/cable|data lead|usb|spc/.test(text)) return "Cables & data";
    if (/back|lug back|flat back/.test(text)) return "Backs";
    if (/stem|bush/.test(text)) return "Stems & bushes";
    if (/holder|stand|base|clamp/.test(text)) return "Holders, stands & clamps";
    if (/extension/.test(text)) return "Extensions";
    if (/lifting|lift lever|release/.test(text)) return "Lifting devices";
    if (/battery/.test(text)) return "Batteries";
    return "Other accessories";
  }
  function classify(template) {
    const record = {
      template,
      title: template.dataset.title || "",
      vendor: template.dataset.vendor || "",
      productType: template.dataset.type || "",
      sku: template.dataset.sku || "",
      price: Number(template.dataset.price || 0),
      tags: tags(template),
    };
    const assigned =
      template.dataset.indicatorAccessory === "true" ||
      template.dataset.accessoryCatalogue === "true" ||
      record.tags.includes("indicator-accessory");
    if (!assigned) return null;
    record.accessoryType = type(record);
    return record;
  }
  async function load(url, page) {
    const target = new URL(url, location.origin);
    target.searchParams.set("view", "mqs-indicator-data");
    target.searchParams.set("page", String(page));
    const response = await fetch(target, { credentials: "same-origin" });
    if (!response.ok) throw Error("Collection HTTP " + response.status);
    const documentPage = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      ),
      feed = documentPage.querySelector("[data-mqsi-feed]");
    if (!feed)
      throw Error("accessory catalogue page " + page + " was incomplete");
    if(Number(feed.dataset.page)!==page)throw Error("Accessory page number mismatch");
    if(/\/collections\/(?:dial-gauge-accessories|dial-gauge-inserts|lever-type-indicator-accessories|all\/indicator-accessory)(?:\/|$)/.test(target.pathname)){
      feed.querySelectorAll("template[data-mqsi-record]").forEach(t=>t.dataset.accessoryCatalogue="true");
    }
    return {
      pages: Number(feed.dataset.pages) || 1,
      items: [...feed.querySelectorAll("template[data-mqsi-record]")],
    };
  }
  function add(select, values) {
    for (const value of [...new Set(values.filter(Boolean))].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true }),
    )) {
      const option = el("option", value);
      option.value = value;
      select.append(option);
    }
  }
  async function init() {
    const host = root();
    if (!host) return;
    const status = host.querySelector("[data-mqsia-status]"),
      grid = host.querySelector("[data-mqsia-grid]"),
      count = host.querySelector("[data-mqsia-count]"),
      pager = host.querySelector("[data-mqsia-pages]"),
      sort = host.querySelector("[data-mqsia-sort]");
    try {
      const sources=(host.dataset.mqsiaSources||host.dataset.mqsiaUrl).split("|").filter(Boolean);
      const batches=[];
      for(const source of sources){
        const first=await load(source,1);batches.push(first);
        if(first.pages>100)throw Error("Accessory catalogue too large");
        for(let start=2;start<=first.pages;start+=4){
          const jobs=[];for(let page=start;page<Math.min(start+4,first.pages+1);page++)jobs.push(load(source,page));
          batches.push(...await Promise.all(jobs));
        }
      }
      const map = new Map();
      for (const template of batches.flatMap((batch) => batch.items))
        if (template.dataset.id) map.set(template.dataset.id, template);
      const records = [...map.values()].map(classify).filter(Boolean);
      if (!records.length)
        throw Error("no indicator accessories were identified in the catalogue");
      const controls = [...host.querySelectorAll("[data-mqsia-filter]")],
        filter = (name) =>
          host.querySelector('[data-mqsia-filter="' + name + '"]');
      add(
        filter("brand"),
        records.map((record) => record.vendor),
      );
      add(
        filter("accessoryType"),
        records.map((record) => record.accessoryType),
      );
      let current = 1;
      function render() {
        const selected = records.filter((record) =>
          controls.every(
            (control) =>
              !control.value ||
              record[control.dataset.mqsiaFilter] === control.value,
          ),
        );
        selected.sort((a, b) =>
          sort.value === "price"
            ? (a.price || Infinity) - (b.price || Infinity) ||
              a.sku.localeCompare(b.sku, undefined, { numeric: true })
            : sort.value === "price-desc"
              ? (b.price || -1) - (a.price || -1) ||
                a.sku.localeCompare(b.sku, undefined, { numeric: true })
              : sort.value === "brand"
                ? a.vendor.localeCompare(b.vendor) ||
                  a.sku.localeCompare(b.sku, undefined, { numeric: true })
                : a.sku.localeCompare(b.sku, undefined, { numeric: true }),
        );
        const pages = Math.max(1, Math.ceil(selected.length / 48));
        current = Math.min(current, pages);
        const start = (current - 1) * 48,
          fragment = document.createDocumentFragment();
        for (const record of selected.slice(start, start + 48))
          fragment.append(record.template.content.cloneNode(true));
        grid.replaceChildren(fragment);
        count.textContent =
          selected.length +
          " indicator accessories" +
          (selected.length
            ? " · showing " +
              (start + 1) +
              "–" +
              Math.min(start + 48, selected.length)
            : "");
        pager.replaceChildren();
        if (pages > 1)
          for (const [label, page] of [
            ["Previous", current - 1],
            ["Page " + current + " of " + pages, current],
            ["Next", current + 1],
          ]) {
            if (page < 1 || page > pages) continue;
            const button = el("button", label);
            button.type = "button";
            button.disabled = page === current;
            button.addEventListener("click", () => {
              current = page;
              render();
              grid.scrollIntoView({ behavior: "smooth" });
            });
            pager.append(button);
          }
      }
      controls.forEach((control) =>
        control.addEventListener("change", () => {
          current = 1;
          render();
        }),
      );
      sort.addEventListener("change", () => {
        current = 1;
        render();
      });
      host.querySelector("[data-mqsia-clear]").addEventListener("click", () => {
        controls.forEach((control) => (control.value = ""));
        sort.value = "sku";
        current = 1;
        render();
      });
      host.querySelector("[data-mqsia-filters]").hidden = false;
      status.textContent = "Choose an accessory type or brand.";
      render();
    } catch (error) {
      status.textContent =
        "Indicator Accessories could not load: " +
        error.message +
        ". Please retry this page.";
      count.textContent = "Indicator accessories could not load.";
    }
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
